module.exports = __webpack_public_path__ + "assets/img/role-3088a050.png";